import { HubNode } from "@/types/types";
import { FaFacebook, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

export const defaultNodes: HubNode[] = [
  {
    id: "1",
    title: "ERP Service Map",
    description: "Centralized ERP workflow and data overview.",
    iconName: "activity",
  },
  {
    id: "2",
    title: "ERP Implementation",
    description: "Odoo deployment, system analysis, data migration.",
    iconName: "database",
  },
  {
    id: "3",
    title: "Business & Process",
    description: "Workflow analysis, gap identification, optimization.",
    iconName: "cpu",
  },
  {
    id: "4",
    title: "Training",
    description: "Role-based user training, adoption & efficiency.",
    iconName: "book",
  },
  {
    id: "5",
    title: "Support",
    description: "Tailored system customization, process alignment.",
    iconName: "tool",
  },
  {
    id: "8",
    title: "Integration",
    description: "Connect ERP with third-party apps & services.",
    iconName: "plug-cable",
  },
  {
    id: "6",
    title: "Data Migration",
    description: "Seamless system unified data flow.",
    iconName: "repeat",
  },
  {
    id: "7",
    title: "Customization",
    description: "Flexible ERP configuration to match business needs.",
    iconName: "settings",
  },
];

export const socialLinks = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/logichub-eg",
    icon: FaLinkedinIn,
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/logichub.eg",
    icon: FaInstagram,
  },
  {
    name: "Facebook",
    url: "https://web.facebook.com/logichub.eg/?_rdc=1&_rdr#",
    icon: FaFacebook,
  },
  {
    name: "X (Twitter)",
    url: "https://x.com/LogicHub_eg",
    icon: BsTwitterX,
  },
];
